import { HorizontalSwitch } from '@/components';
import { R } from '@/features/shared/features/addOrEditChild/resources/AddChildResources.resx';
import { Utils } from '@/shared/Utils';

export function ChildTerms({
    hasAcceptedTerms,
    setHasAcceptedTerms,
}: {
    hasAcceptedTerms: boolean;
    setHasAcceptedTerms: (value: boolean) => void;
}) {
    return (
        <HorizontalSwitch
            title={
                <div>
                    <b>{R.ChildTermsTitle}</b>

                    <ul className="list-disc pl-5">
                        <li>{R.ChildTermsBullet1}</li>
                        <li
                            dangerouslySetInnerHTML={{
                                __html: Utils.decodeHtml(R.ChildTermsBullet2),
                            }}
                        />
                    </ul>
                </div>
            }
            checked={hasAcceptedTerms}
            onChangeChecked={setHasAcceptedTerms}
            switchOnLeft={true}
            useSmallText={true}
        />
    );
}
